import { type FC } from 'react';
import { ClaimAnimationProvider } from '@context/ClaimAnimationContext';

import { useExtendedInfoQuery } from '@/api/queries/user';

import ResourceMine from '../mineResource/ResourceMine';

const Quarry: FC = () => {
  useExtendedInfoQuery();

  return (
    <ClaimAnimationProvider>
      <ResourceMine />
    </ClaimAnimationProvider>
  );
};

export { Quarry };
